// extracted by mini-css-extract-plugin
export default {"header":"Header_header__O3olx","logo":"Header_logo__pyJmH","nav":"Header_nav__9sok9","heddin":"Header_heddin__blthx","menue":"Header_menue__NNfKO","navBar":"Header_navBar__5J0mJ"};